import * as React from "react";
import Chip from "@mui/material/Chip";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch, useSelector } from "react-redux";

import TextField from "@mui/material/TextField";
import { store } from "../../redux/store";

const GroupsSelector = (props) => {
  const statistic = useSelector((state) => state?.statisticsSlice?.statistic);
  const widget = useSelector((state) => state?.widgetsSlice?.widgetShow);

  const statisticUpdating = useSelector(
    (state) => state?.statisticsSlice?.updating
  );
  const widgetUpdating = useSelector((state) => state?.widgetsSlice?.updating);
  const [value, setValue] = React.useState();
  const rls = useSelector((state) => state?.aegisSlice?.roles);
  const roles = useSelector((state) => state?.aegisSlice?.roles)?.map(
    (item) => ({
      title: item,
      value: item,
    })
  );
  const statisticValue = statistic?.groups?.map((item) => ({
    title: item,
    value: item,
  }));
  const widgetValue = widget?.attributes?.groups?.map((item) => ({
    title: item,
    value: item,
  }));
  React.useEffect(() => {
    /*  getPreference(); */
    if (!rls) {
      getRoles();
    }

    return () => {
      setValue(null);
    };
  }, []);
  React.useEffect(() => {
    if (!statisticUpdating && !widgetUpdating) {
      setValue([]);
    }
  }, [statisticUpdating, widgetUpdating]);
  const [getRoles] = store.useLazyGetAllrolesQuery();
  const [getPreference] = store.useLazyGetPreferenceQuery();
  React.useEffect(() => {}, [props]);
  React.useEffect(() => {
    if (statistic && statisticUpdating) {
      setValue(
        statistic?.groups?.map((item) => ({
          title: item,
          value: item,
        }))
      );
    }
  }, [statistic]);
  React.useEffect(() => {
    if (widget && widgetUpdating) {
      setValue(
        widget?.attributes?.groups?.map((item) => ({
          title: item,
          value: item,
        }))
      );
    }
  }, [widget]);
  React.useEffect(() => {
    if (value) {
      props.onChange(value?.map((item) => item.value));
    }
  }, [value]);
  React.useEffect(() => {}, [value]);
  return (
    <>
      {roles && !statisticUpdating && !widgetUpdating && (
        <Autocomplete
          multiple
          value={value}
          id="tags-outlined"
          options={roles}
          getOptionLabel={(option) => option.title}
          filterSelectedOptions
          onChange={(e, newValue) => {
            setValue(newValue);
          }}
          renderInput={(params) => (
            <TextField
              error={props?.rawErrors?.length > 0}
              {...params}
              label="Groups"
            />
          )}
        />
      )}
      {roles && value && (statisticUpdating || widgetUpdating) && (
        <Autocomplete
          multiple
          value={value}
          id="tags-outlined"
          options={roles}
          getOptionLabel={(option) => option.title}
          filterSelectedOptions
          onChange={(e, newValue) => {
            setValue(newValue);
          }}
          renderInput={(params) => (
            <TextField
              error={props?.rawErrors?.length > 0}
              {...params}
              label="Groups"
            />
          )}
        />
      )}
    </>
  );
};
export default GroupsSelector;
